<template>
  <pt-order-table class="pt-order-table__withData" @getOrderList="getOrderList" :total-number="totalNumber" :table-data="tableData" :pageSize="pageSize"
                  ref="table" :isOutside="isOutside" :loading="loading">
    <slot />
  </pt-order-table>
</template>

<script>
import PtOrderTable from './index'
export default {
  name: 'pt-order-table__withData',
  components: {
    'pt-order-table': PtOrderTable
  },
  props: {
    queryParams: {
      type: Object,
      default: function () {
        return {}
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    isFromRouter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      totalNumber: 0,
      tableData: [],
      // 是否外部默认调用一次列表函数
      isOutside: false,
      loading: false
    }
  },
  watch: {
    queryParams: {
      handler: function (val, old) {
        console.log('this.page', this.page)
        if (!this.isFromRouter) {
        //   this.getOrderList(0)
          console.log('0')
          this.$refs.table.resetPage()
        } else {
          console.log(1)
          this.isOutside = true
          this.getOrderList(this.page)
        }
      },
      deep: true
    },
    '$route.name': {
      handler: function (val) {
        this.getOrderList(this.page)
      }
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    },
    layoutName () {
      return this.$route.name
    }
  },

  methods: {
    getOrderList (page, next, size) {
      let data = {
        ...this.queryParams,
        pageable: {
          page: page,
          size: size || this.pageSize,
          sort: (this.queryParams.orderCreateTimeStart && this.queryParams.orderCreateTimeEnd) ? 'orderTime,asc' : 'orderTime,desc'
        }
      }
      if (!next) {
        this.loading = true
      }
      if (this.layoutName === 'renew-deposit-order') {
        data.goodsId = '62284056f9c5b70001a6d550'
      } else if (this.layoutName === 'immune_storage-order') {
        data.goodsId = '624ebcfe36422c0001fa5083'
      }
      this.$store.dispatch('getMallOrderOfAll', data).then(res => {
        if (next) {
          next(res.data)
        } else {
          this.loading = false
        }
        this.totalNumber = res.totalNumber
        this.tableData = res.data
      }).catch(err => {
        this.loading = false
        this.$refs.table.showReTry()
        this.$message.error(err || '查询订单列表失败')
      })
    }
  }
}
</script>
